import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import DataGridKeywordExact from "src/components/data-grid/activations/data-grid-keyword-exact";
import { useGetKeywordsQuery } from "src/context/api/activations/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";

export default function ActivationsKeywordOther() {
    const workspace = useCurrentWorkspace();

    // Pagination
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    // Récupération des données exact keywords
    const { data: keywordsExact, isFetching, refetch } = useGetKeywordsQuery(
        {
            client: workspace?.bqTable,
            page: page + 1,
            page_size: pageSize,
            workspace_id: workspace?.id,
            match_type: "OTHER"
        },
        { skip: !workspace }
    );

    // Rendu
    return (
        <Box sx={{ backgroundColor: '#212B36' }}>
            {isFetching ? (
                <Skeleton
                    variant="rectangular"
                    height={400}
                    width="100%"
                    animation="wave"
                />
            ) : (
                <DataGridKeywordExact
                    data={keywordsExact?.data ?? []}
                    rowCount={keywordsExact?.total ?? 0}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={setPage}
                    onPageSizeChange={setPageSize}
                    refetch={refetch}
                />
            )}
        </Box>
    );
}
